import React, {useState} from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Login from "./pages/auth/Login";
import './App.css';
import ProfilePage from "./pages/ProfilePage";
import {AuthProvider, useAuth} from "./utils/auth.context";
import {ProtectedRoute, PublicRoute} from "./components/Auth/ProtectedRoute";
import GlobalLayout from "./components/Layout/Global";
import UsersPage from "./pages/UsersPage";
import ProjectsPage from "./pages/ProjectsPage";
import Register from "./pages/auth/Register";
import config from "./config";
import {getCurrentUser} from "./services/authService";
import NotFound from "./components/NotFound";
import MyProjectsPage from "./pages/MyProjectsPage";
import LoadingSpinner from "./components/LoadingSpinner";
import {ProjectProvider} from "./components/ProjectProvider";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {

    const user = getCurrentUser()
    const [loading, setLoading] = useState(false);


    const simulateLoading = () => new Promise(resolve => setTimeout(resolve, 1000));

    const handleRouteChange = async () => {
        setLoading(true);
        await simulateLoading();
        setLoading(false);
    };


    // todo
    return (
        <Router>
            <ProjectProvider>
                <ToastContainer />
                {loading && <LoadingSpinner/>}
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<PublicRoute/>}>
                            <Route path="/login" element={<Login/>}/>
                        </Route>
                        <Route path="/account/activate" element={<PublicRoute/>}>
                            <Route path="/account/activate" element={<Register/>}/>
                        </Route>

                        <Route element={<ProtectedRoute/>}>
                            <Route element={<GlobalLayout/>}>
                                {/*{user !== null && user?.role === config.roles.admin &&*/}
                                <Route path="/users" element={<UsersPage/>}/>
                                {/*}*/}
                                {/*{user !== null && user?.role === config.roles.admin && */}
                                <Route path="/projects" element={<ProjectsPage/>}/>
                                {/*}*/}
                                {/*{(user !== null && (user?.role === config.roles.manager || user.data.role === config.roles.editor)) &&*/}
                                <Route path="/my-projects" element={<MyProjectsPage/>}/>
                                {/*}*/}

                                <Route path="/profile" element={<ProfilePage/>}/>
                                <Route path="/" element={<ProfilePage/>}/>
                            </Route>
                        </Route>

                        <Route path="*" element={<NotFound/>}/>
                    </Routes>

                </AuthProvider>
            </ProjectProvider>
        </Router>
    );
}

export default App;
